import { isEmptyWhereClause } from '@modules/common/utils';
import { useDashboardStore } from '@modules/dashboard/store/useDashboardStore';
import { FeedDefinitionInfo } from '@modules/feed/components/FeedDefinitionInfo';
import { QuantifyDefinitionInfo } from '@modules/quantify/components/QuantifyDefinitionInfo';
import { FilterAltRounded } from '@mui/icons-material';
import { alpha, Box, IconButton, Tooltip } from '@mui/material';
import { AnalysisUseCase, AnalysisViewFragment } from 'generated/graphql';

interface DashboardAnalysisHeaderFiltersInfoIconProps {
  analysis: AnalysisViewFragment;
}

export const DashboardAnalysisHeaderFiltersInfoIcon = ({
  analysis,
}: DashboardAnalysisHeaderFiltersInfoIconProps) => {
  const isDashboardWhereClauseApplied = useDashboardStore(
    ({ query }) => !isEmptyWhereClause(query.whereClause),
  );

  return (
    <Tooltip
      title={
        <Box
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
          }}
        >
          {analysis.useCase === AnalysisUseCase.Feed ? (
            <FeedDefinitionInfo shouldHideTooltips />
          ) : (
            <QuantifyDefinitionInfo shouldHideTooltips />
          )}
        </Box>
      }
      placement="right-start"
      arrow
      componentsProps={{
        tooltip: {
          sx: {
            opacity: 1,
            bgcolor: (theme) => theme.palette.misc.drawer.background,
            color: 'text.primary',
            maxWidth: '400px',
            border: '1px solid',
            borderColor: (theme) => alpha(theme.palette.text.primary, 0.1),
            maxHeight: '500px',
            overflowY: 'auto',
            overflowX: 'hidden',
          },
        },
        arrow: {
          sx: {
            '&::before': {
              opacity: 1,
              bgcolor: (theme) => theme.palette.misc.drawer.background,
              border: '1px solid',
              borderColor: (theme) => alpha(theme.palette.text.primary, 0.1),
            },
          },
        },
      }}
    >
      <IconButton
        disableRipple
        sx={{
          '&:hover': {
            backgroundColor: (theme) =>
              alpha(
                isDashboardWhereClauseApplied
                  ? theme.palette.info.main
                  : theme.palette.primary.main,
                0.2,
              ),
          },
        }}
        aria-label="dashboard-analysis-filter-info-icon"
        color={isDashboardWhereClauseApplied ? 'info' : 'primary'}
        size="small"
      >
        <FilterAltRounded
          sx={{
            fontSize: '1.5rem',
          }}
        />
      </IconButton>
    </Tooltip>
  );
};
